import React from 'react';
import styles from './applyFilterPopover.scss';
import { useStratsContext } from '@/finsight/application/Strats/StratsContext';

const ApplyFilterPopover = () => {
  const { applyFilter, popover: { offsetTop, offsetLeft } } = useStratsContext();

  const outerStyle = {
    display: offsetTop && offsetLeft ? 'block' : 'none',
    top: offsetTop,
    left: offsetLeft,
  };

  return (
    <div
      className={ styles.popoverContainer }
      style={ outerStyle }
    >
      <div className={ styles.popoverBody }>
        <div className={ styles.popoverArrow } />
        <div className={ styles.popoverContent }>
          <button
            type="button"
            className={ styles.applyFilterButton }
            onClick={ applyFilter }
            data-test="applyFilterPopoverButton"
          >
            Apply Filters
          </button>
        </div>
      </div>
    </div>
  );
};

export default ApplyFilterPopover;
